import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n';
import { ref, onMounted, reactive } from 'vue';
import serveSettingApi from '@/api/serve-setting'
import { random } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const coverArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
let activeBack = ref(0);
let backRandom = ref(true);

const form = reactive({
    interval: '',
    autoCompress: 0,
    // 证书pem文件
    pem: '',
    // 证书key文件
    key: '',
    posterSize: 100,
    saveDuration: 30,
})

function back_random(val: boolean) {
    activeBack.value = 0;
    localStorage.setItem('activeBack', String(0));
}

function back_click(item: number) {
    backRandom.value = false;
    activeBack.value = item;
    localStorage.setItem('activeBack', String(item));
}

/**
 * @description: 设置扫描时间间隔
 * @return {*}
 */
async function comfirm_interval() {
    serveSettingApi.set('scan', 'interval', form.interval)
}

/**
 * @description: 设置自动解压开关
 * @return {*}
 */
async function comfirm_auto_compressl() {
    serveSettingApi.set('scan', 'autoCompress', form.autoCompress)
}

async function confirm_poster_size() {
    serveSettingApi.set('poster', 'size', form.posterSize)
}

async function confirm_compress_duration() {
    serveSettingApi.set('compress', 'saveDuration', form.saveDuration)
}

/**
 * @description: 设置ssl证书
 * @return {*}
 */
async function comfirm_ssl() {
    serveSettingApi.set_ssl(form.pem, form.key);
}

/**
 * @description: 重置证书设置
 * @return {*}
 */
async function reset_ssl() {
    serveSettingApi.reset_ssl();
}

onMounted(async () => {
    const res = await serveSettingApi.get();
    Object.assign(form, res);

    const val = localStorage.getItem('activeBack');
    if (val && val!=='0') {
        activeBack.value = Number(val);
        backRandom.value = false;
    }
})


const __returned__ = { coverArr, get activeBack() { return activeBack }, set activeBack(v) { activeBack = v }, get backRandom() { return backRandom }, set backRandom(v) { backRandom = v }, form, back_random, back_click, comfirm_interval, comfirm_auto_compressl, confirm_poster_size, confirm_compress_duration, comfirm_ssl, reset_ssl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})